import { DiscoveryPageLayout } from './SiteShell';
import { SettingsPageLayout } from './SettingsPageLayout';

type FallbackProps = {
  title?: string;
  description?: string;
};

export function DiscoverySuspenseFallback({
  title = 'Loading…',
  description,
}: FallbackProps) {
  return (
    <DiscoveryPageLayout title={title} description={description}>
      <p className="text-muted">Loading…</p>
    </DiscoveryPageLayout>
  );
}

export function SettingsSuspenseFallback({
  title = 'Loading…',
  description,
}: FallbackProps) {
  return (
    <SettingsPageLayout title={title} description={description}>
      <p className="text-muted">Loading…</p>
    </SettingsPageLayout>
  );
}

export function LegalSuspenseFallback({ title = 'Loading…' }: { title?: string }) {
  return (
    <DiscoveryPageLayout title={title}>
      <article className="legal-page feed-card">
        <p className="text-muted">Loading…</p>
      </article>
    </DiscoveryPageLayout>
  );
}
